// 引入vue
import Vue from 'vue';
// 引入vuex
import Vuex from 'vuex';
// 引入getters
import getters from "./getters";
// 注册vuex
Vue.use(Vuex);

import souye from "./modules/home";
// 引入背景图片
import bgImg from "./modules/bgImg";
// 引入经典案例信息
import caseList from "./modules/caseList";
// 引入新闻资讯信息
import newsList from "./modules/newsList";
// 引入产品信息
import productList from "./modules/productList";
// 引入公司简介信息
import companyProfile from "./modules/companyProfile";

// Store应为大写
// 创建store仓库暴露出去
export const store = new Vuex.Store({
    modules: {
        bgImg,
        souye,
        caseList,
        newsList,
        productList,
        companyProfile
    },
    // 用来获得state里面的数据的
    getters,

});